import { useMapGetter } from 'dashboard/composables/store';

/**
 * Resolves the colored dot shown for an availability status key.
 *
 * Built-in statuses (online/busy/offline) keep their semantic Tailwind class so
 * they stay theme-aware, while custom account statuses are painted with the hex
 * color configured in Settings → Availability statuses.
 */
export function useAccountStatusIndicator() {
  const statuses = useMapGetter('accountStatuses/getStatuses');

  /**
   * @param {string} key - availability status key (built-in or custom)
   * @param {Object} classMap - base availability -> Tailwind background class
   * @returns {{ class?: string, style?: Object }|null} null when the status
   * should not render an indicator at all (e.g. offline is omitted from classMap)
   */
  const indicatorFor = (key, classMap) => {
    const status = statuses.value.find(item => item.key === key);
    const colorClass = classMap[status?.base_availability || key];

    if (!colorClass) return null;

    return status && !status.builtin
      ? { style: { backgroundColor: status.color } }
      : { class: colorClass };
  };

  return { indicatorFor };
}
